// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/app-card/app-card.component.scss
// module id = 109
// module chunks = 0